import EventBus from '../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'

class ManualAddressForm {
    
    /**
     * Construct component
     * @param form
    */
    constructor(form) {
        
        /**
         * Form jQuery object
         * @type {object}
        */
        this.form = form
        
        /**
         * Address autocomplete jQuery object
         * @type {object}
        */
        this.autocomplete = jQuery('#address_autocomplete')
        
        /**
         * Modal container jQuery object
         * @type {object}
        */
        this.container = jQuery('#address-modal')
        
        /**
         * Country select jQuery object
         * @type {object}
        */
        this.countrySelect = jQuery('#country')
        
        this.bindEvents()
        
    }
    
    /**
     * Modal showing
    */
    modalShowing() {
        
        let
            input,
            name
        
        //Synchronise values from hidden inputs to modal form
        this.form.find('input, select:not([name="country"])').each((i, element) => {
            input = jQuery(element)
            name = input.attr('name')
            input.val(this.autocomplete.siblings('[name="address[' + name + ']"]').val())
        })
        
        //Get country text
        const country = this.autocomplete.siblings('[name="address[country]"]').val()
        
        //Update country select value
        this.countrySelect.find('option').filter((i, element) => {
            return jQuery(element).text() === country
        }).prop('selected', true)
        
        //Trigger change on country select so that correct state input shows
        this.countrySelect.trigger('change')
        
    }
    
    /**
     * Handle successful form submit
    */
    formSuccess() {
        
        var address = ''
            
        let
            input,
            name,
            value
        
        //Apply form values to autocomplete hidden inputs
        this.form.find('input, select').each((i, element) => {
            
            input = jQuery(element)
            name = input.attr('name')
            value = input.val()
            
            //Skip if input is disabled
            if (input.is(':disabled')) {
                return
            }
            
            //Apply input value to address string
            if (value) {
                address += (address.length > 0 ? ', ' : '') + value
            }
            
            //Copy input value to hidden autocomplete sibling
            this.autocomplete.siblings('[name="address[' + name + ']"]').val(value)
            
        })
        
        //Apply address string to autocomplete
        this.autocomplete.val(address)
        
        //Close modal
        this.container.modal('hide')
        
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Modal opening
        this.container.on('show.bs.modal', this.modalShowing.bind(this))
        
        //Form success
        this.form.on('form-success', this.formSuccess.bind(this))
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    let form = jQuery('#manual-address-form')
    
    if (form.length > 0) {
        new ManualAddressForm(form)
    }
    
})

export default ManualAddressForm